module.exports = __webpack_public_path__ + "static/media/ops.7a9592ca.svg";